module.exports = __webpack_public_path__ + "img/nube-palabras.85685b5c.png";